import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';

// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus, true);

    const response = await fetch('/snelstart/executeImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });
    if (response.ok) {
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0});
  }
}

export async function getSnelstartCompany(userId){
  const response = await fetch('/snelstart/getCompany', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: userId,
    }),
  });
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      return responseData;
    }
  }
}

export async function setImportSnelstarLink(currentUser, refCode){
  try {
    var response = await fetch('/snelstart/setImportSnelstarLink?refCode='+refCode+'&userId='+currentUser);

    var responseData = await response.json();
    console.log(responseData);
  }
  catch (error){
    console.error('Error fetching data:', error);
  }
}

export async function getAdministrations(currentUser){
  var response = await fetch('/import_snelstartlink/getAdministrations?userId='+currentUser);
  if(response.ok){
    var responseData = await response.json();
    var administration = [];
    if(responseData && responseData.length > 0){
      responseData.forEach(function(data){
        administration.push({"Code": data.administration_id, "Description": data.administration_name, "ID": data.id});
      });
    }
    
    return administration;
  }
}

async function findByDivision(office){
  var response = await fetch('/import_snelstart/getListArray?division='+office);
  if(response.ok){
    var responseData = response.json();
    return responseData;
  }
}

// Update import exact factview and exactonline tokens
export async function updateImportSnelstartByOffice(office){
  var imp = await findByDivision(office);
  if(imp){
    for(var i = 0; i < imp.length; i++){
      await fetch('/import_snelstart/updateImportSnelstartTokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: imp[i].id,
          factview_access: getCookie('factview_access'),
          factview_refresh: getCookie('factview_refresh'),
          exact_access: getCookie('exact_access'),
          exact_refresh: getCookie('exact_refresh'),
        }),
      });  
   }
  }
  
}

export async function getImportSnelstart(mvLink){
  try{
    const response = await fetch('/snelstart/getImportSnelstart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        snelstart_link: mvLink
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function createImportSnelstart(importConfig){
  try{
    updateUserLastAction();
    const response = await fetch('/snelstart/createImportSnelstart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(importConfig),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}



//Submits import snelstart updates/changes
export async function updateImportSnelstart(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_snelstart/updateImportSnelstart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportSnelstart(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_snelstart/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "snelstart", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]});
      
      const response = await fetch('/import_snelstart/deleteImportSnelstart?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

// Handles fetching status updates from the server
async function handleStatus(updateStatus, init){
  try{
    if(init){
      await fetch('/snelstart/resetStatus');
      setTimeout(function(){
        handleStatus(updateStatus, false, 0);
      },500);
    }else{
      const response = await fetch('/snelstart/fetchUpdates');
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          updateStatus(responseData);

          if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
            setTimeout(function(){
              handleStatus(updateStatus, false);
            }, 750);
          }
        } 
      }
    }
  } catch(error) {
    setTimeout(function(){
      handleStatus(updateStatus, false);
    },500);
  }
  
}


